import { QuestionCoSleeping as Question } from "@/components/features/items/edit/plan/_shared/ui/components/kids-policy/co-sleeping";

import { usePlanCoSleeping } from "./hooks/use-co-sleeping/use-co-sleeping";

export const QuestionDayTripCoSleeping = () => {
	const { isCoSleepingKidsPriceActive, amount, onChangeIsCoSleepingKidsPriceActive, onChangeCoSleepingKidsPrice } =
		usePlanCoSleeping();

	return (
		<Question
			isCoSleepingKidsPriceActive={isCoSleepingKidsPriceActive}
			amount={amount?.value}
			amountError={amount?.error}
			onChangeIsCoSleepingKidsPriceActive={onChangeIsCoSleepingKidsPriceActive}
			onChangeCoSleepingKidsPrice={onChangeCoSleepingKidsPrice}
		/>
	);
};

QuestionDayTripCoSleeping.displayName = "QuestionDayTripCoSleeping";
